import React from 'react';
import { Avatar, Button, Chip, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { CalendarToday, Close, LocalHospital, Person } from '@mui/icons-material';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { moneyFormat } from 'helpers/moneyFormat';
import history from 'services/history';
import { Guide } from 'types/guide';
import { getGuideDate, getInitials, getStatusLabel } from './agenda';
import { CloseButton, DetailLine, DetailsGrid, DetailsHeader, DetailValue, GuideDialog } from './HomeStyles';

interface GuideDetailsDialogProps {
  guide: Guide | null;
  onClose(): void;
}

const GuideDetailsDialog: React.FC<GuideDetailsDialogProps> = ({ guide, onClose }) => {
  const date = guide ? getGuideDate(guide) : null;

  return (
    <GuideDialog open={!!guide} onClose={onClose} maxWidth="sm" fullWidth>
      {guide && date && (
        <>
          <DialogTitle>
            <DetailsHeader>
              <Avatar>{getInitials(guide.patient?.name)}</Avatar>
              <div>
                <Typography variant="subtitle2">{guide.patient?.name || 'Paciente não informado'}</Typography>
                <Typography variant="caption" color="text.secondary">
                  Guia #{guide.id}
                </Typography>
              </div>
              <Chip size="small" label={getStatusLabel(guide.status)} />
              <CloseButton size="small" onClick={() => onClose()}>
                <Close fontSize="small" />
              </CloseButton>
            </DetailsHeader>
          </DialogTitle>

          <DialogContent>
            <DetailsGrid>
              <DetailLine>
                <CalendarToday fontSize="small" />
                <span>
                  {format(date, "EEEE, dd/MM/yyyy 'às' HH:mm", {
                    locale: ptBR,
                  })}
                </span>
              </DetailLine>

              <DetailLine>
                <LocalHospital fontSize="small" />
                <span>{guide.procedure?.name || 'Consulta não informada'}</span>
              </DetailLine>

              <DetailLine>
                <Person fontSize="small" />
                <span>{guide.doctor?.name || 'Médico não informado'}</span>
              </DetailLine>

              <DetailValue>
                <Typography variant="caption" color="text.secondary">
                  Valor
                </Typography>
                <Typography variant="h6">{moneyFormat(Number(guide.value_total || 0))}</Typography>
              </DetailValue>
            </DetailsGrid>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => history.push(`/guides/${guide.id}/print`)} size="small" variant="contained">
              Imprimir guia
            </Button>
          </DialogActions>
        </>
      )}
    </GuideDialog>
  );
};

export default GuideDetailsDialog;
